// Sostituire lo stato sopra con uno di quelli sotto
export const CLOUD_STATUS_OK = 0;
export const CLOUD_STATUS_MAINTENANCE = 1;

/** Intervallo di polling dello stato cloud (ms). */
export const MAINTENANCE_POLLING_INTERVAL_MS = 30_000;

/**
 * Placeholder: l'endpoint effettivo è configurato in `environment.apiStatus`
 * (es. https://status.cameconnect.net/servicestatus/frontend/prod.json).
 */
export function isCloudInMaintenance(status: number | null | undefined): boolean {
	return (status ?? CLOUD_STATUS_OK) > CLOUD_STATUS_OK;
}